export default __webpack_public_path__ + "static/media/celebration.010d68f4.svg";